import React, { useState, useEffect } from 'react'
import {Flex, Button, Box, Heading, Text, Spacer, HStack, VStack, Image, useDisclosure, useColorModeValue,Modal, ModalBody, ModalOverlay, ModalContent,Spinner} from "@chakra-ui/react"
import {CCarousel, CCarouselItem, CImage, CCarouselCaption} from "@coreui/react"
import { useNavigate } from "react-router-dom";
import Link from "./Link";
import MenuCard from './MenuCard';
import BannerSlick from './BannerSlick';
import NextLink from 'next/link'
import LoadingPage from './LoadingPage';


function Exclusiveforyou() {
    const navigate = useNavigate();
    
    let textColor = useColorModeValue("#565E6D");
    const trueshopUrl = "https://bit.ly/smartlife-application-web"
    const bannerArr = [ {banner:"/banner/SmartShoppingBanner.png",path:'/smartShoppingWorkArt'}, {banner:"/banner/SmartLearningBanner.png",path:"/smartLearningWorkart"}, {banner:"/banner/SmartEntertainmentBanner.png",path:"/smartEntertainmentWorkart"} ,{banner:"/banner/MordeeBanner.png",path:"/smarthealthWorkart"}];


    const { isOpen: isLoading , onOpen: onLoadingOpen, onClose: onLoadingClose } = useDisclosure()
    return (
        
        <>
        <LoadingPage
        isLoading={isLoading}
        onLoadingClose={onLoadingClose}
        />

            

            <BannerSlick banner={bannerArr}/>
            
            {/* 
            <Flex pt={'14px'} alignItems='center'>
                <Link to={"/smartSeriesPackage"} >
                    <Image src={process.env.PUBLIC_URL + "/banner/SmartSeries.png"}  alt="SmartSeries"/>
                </Link>
            </Flex>
            */}
            
            

            
            <Flex minWidth='max-content' alignItems='center'>
                <Box pl='5' pt='5'>
                    <Text color={textColor} fontSize='18px' fontWeight='700' mt='14px'>The Service Menu</Text>

                </Box>
            </Flex>

            <Flex alignItems='center' justifyContent={'space-around'} flexDirection='row' flexWrap='wrap' gap={'8px'} padding={'10px'}>
                {/* <VStack spacing='0px'>
                    <Button variant="text" size="small" style={{display: "flex", flexDirection: "column"}}>
                        <a href={'#'} onClick={()=>navigate("/marketplace")}>
                            <img src={process.env.PUBLIC_URL + "/icon/marketplace_icon.png"} width="90" alt="folder"/>
                        </a>
                    </Button>
                    <Text fontSize='xs'>Market Place</Text>
                </VStack> */}
                <MenuCard 
                banner={process.env.PUBLIC_URL + "/icon/SmartHome.png"}
                title={"Smart Home Services"}
                link={"/homeservices"}
                activate={true}
                onClick={onLoadingOpen}
                />
                
                <MenuCard 
                banner={process.env.PUBLIC_URL + "/icon/health.png"}
                title={"Smart Health"}
                link={'/health'}
                activate={true}
                onClick={onLoadingOpen}
                />
                <MenuCard 
                banner={process.env.PUBLIC_URL + "/icon/commerce.png"}
                title={"Smart Shopping"}
                link={trueshopUrl}
                activate={true}
                onClick={onLoadingOpen}
                />
                <MenuCard 
                banner={process.env.PUBLIC_URL + "/icon/education.png"}
                title={"Smart Learning"}
                link={'https://vcourse.ai/'}
                activate={true}
                onClick={onLoadingOpen}
                />

                <MenuCard 
                banner={process.env.PUBLIC_URL + "/icon/entertainment.png"}
                title={"Smart Entertainment"}
                link={"/Entertainment"}
                activate={true}
                onClick={onLoadingOpen}
                />

                <MenuCard 
                banner={process.env.PUBLIC_URL + "/icon/utilities.png"}
                title={"Smart Utilities"}
                link={"/utilities"}
                activate={true}
                onClick={onLoadingOpen}
                />

            {/* link={'https://ttid.co/UAnK/4lhkwaky'}*/}

                {/* <VStack spacing='0px'>
                    <Button variant="text" size="small" style={{display: "flex", flexDirection: "column"}}>
                        <a href={'#'} onClick={()=>navigate("/health")}>
                            <img src={process.env.PUBLIC_URL + "/icon/health_icon.png"} width="90" alt="folder"/>
                        </a>
                    </Button>
                    <Text fontSize='xs'>Health</Text>
                </VStack>
                <VStack spacing='0px'>
                        <Button onClick={onOpen} variant="text" size="small" style={{display: "flex", flexDirection: "column"} }>
                        <img src={process.env.PUBLIC_URL + "/icon/homeservices_icon.png"} width="90" alt="folder"/>
                        </Button>
                        <Seekster
                            open={isOpen}
                            onClose={() => onClose()} />
                
                    
                    
                    <Text fontSize='xs'>Home Services</Text>
        
                </VStack>*/}
                
                { /*<VStack spacing='0px'>
                <Button variant="text" size="small" style={{display: "flex", flexDirection: "column"}}>
                    <a href={'#'} onClick={()=>navigate("/partners")}>
                            <img src={process.env.PUBLIC_URL + "/icon/marketplace_icon.png"} width="90" alt="folder"/>
                        </a>
                    </Button>
                    <Text fontSize='xs'>Partners</Text>
            </VStack> */ }
            </Flex>

        </>
    );
}



export default Exclusiveforyou;